/**
 * Created by akrio on 2018/3/23.
 */
import axios from "../utils/fetch";
import axios1 from "axios";
/**
 * 获取上传至 AWS 的必要数据
 * http://schedulepost.dev.apphi.com/api/docs/#!/publishers/Publisher_Authentication_POST
 */
export function postSignature({ key, type = "image/jpeg" }) {
  return axios.get("aws_services/post_signature", {
    params: {
      key,
      type,
    },
  });
}
/**
 * aws图片上传
 * https://gist.github.com/iwangpeng/f254ff9687b6dd850db626273fa7cb51
 * @param url
 * @param key
 * @param algorithm
 * @param credential
 * @param date 当前时间
 * @param acl
 * @param contentType
 * @param signature
 * @param file 上传文件
 */
export function upload({
  url,
  key,
  algorithm,
  credential,
  date,
  acl,
  contentType,
  policy,
  signature,
  file,
}) {
  let formData = new FormData();
  formData.append("key", key);
  formData.append("x-amz-algorithm", algorithm);
  formData.append("x-amz-credential", credential);
  formData.append("x-amz-date", date);
  formData.append("acl", acl);
  formData.append("Content-Type", contentType);
  formData.append("policy", policy);
  formData.append("x-amz-signature", signature);
  formData.append("file", file);
  return axios1.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
